import { Role } from './role';

export class UserGroup {
    id: string;
    name: string;
    publisherId: string;
    userGroupRoles: UserGroupRole[];
}

export class UserGroupRole {
    userGroupId: string;
    roleId: string;
    role: Role;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/user-group.ts